import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import fav_icon from "./favicon.svg";

const SITE_URL = "https://urxprt.com";

// Each page is its own canonical: SITE_URL + path, no query or trailing slash.
// The bare root redirects to the English home page, so it points at /en.
const getCanonicalUrl = (pathname) => {
  const path = pathname.replace(/\/+$/, "") || "/en";
  return `${SITE_URL}${path}`;
};

const HelmetAllInOne = () => {
  const location = useLocation();

  useEffect(() => {}, [location.pathname]);

  const getPageDetails = () => {
    let meta_title = "URExpert - Your Destination for Remote Work and More";
    let meta_description =
      "URExpert offers a wide range of remote work opportunities, jobs, projects, auctions, and services. Find your next remote job or project today!";
    let h1 = "URExpert - Remote Work and More";
    let url = "/";
    let canonical = "";
    let author = "URExpert";
    let robots = "index, follow";
    let image = fav_icon;

    switch (location.pathname) {
      case "/jobs":
        meta_title = "Remote Jobs - URExpert";
        meta_description =
          "Find remote jobs in various fields such as software development, design, marketing, and more on URExpert.";
        h1 = "Remote Jobs";
        url = "/jobs";
        canonical = "remote-jobs";
        break;
      case "/projects":
        meta_title = "Remote Projects - URExpert";
        meta_description =
          "Browse remote projects and freelance opportunities on URExpert. Get hired or find skilled professionals for your projects.";
        h1 = "Remote Projects";
        url = "/projects";
        canonical = "remote-projects";
        break;
      case "/auctions":
        meta_title = "Auctions - URExpert";
        meta_description =
          "Participate in online auctions for remote work, services, and projects. URExpert connects buyers and sellers worldwide.";
        h1 = "Auctions";
        url = "/auctions";
        canonical = "auctions";
        break;
      // Add cases for other pages as needed
      default:
        meta_title = "URExpert";
        meta_description =
          "Participate in online auctions for remote work, services, and projects. URExpert connects buyers and sellers worldwide.";
        h1 = "Main Page";
        url = "/";
        canonical = "homepage";
        break;
    }

    const canonicalUrl = canonical
      ? `https://www.URExpert.com/${canonical}`
      : "https://www.URExpert.com/";

    return {
      meta_title,
      meta_description,
      h1,
      url,
      canonical,
      author,
      robots,
      image,
      canonicalUrl,
    };
  };

  const {
    meta_title,
    meta_description,
    h1,
    url,
    author,
    robots,
    image,
  } = getPageDetails();

  return (
    <>
      <Helmet>
        {/* Title and description live in index.html so crawlers that don't
            run JavaScript see them, and React 19 doesn't de-duplicate them */}
        <link rel="icon" href={fav_icon} />
        <meta name="author" content={author} />
        <meta name="robots" content={robots} />
        <meta property="og:url" content={url} />
        <link rel="canonical" href={getCanonicalUrl(location.pathname)} />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://www.URExpert.com/${url}`}
        />
        <meta property="og:title" content={meta_title} />
        <meta property="og:description" content={meta_description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={`https://www.URExpert.com/${url}`} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="URExpert" />
        <meta property="og:locale" content="en" />
      </Helmet>
      <h1 style={{ display: "none" }} className="seo">
        {h1}
      </h1>
    </>
  );
};

export default HelmetAllInOne;
